import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CountriesService {
  baseUrl = environment.apiEndpoint + '/countries/';

  private countries$: Observable<any[]> | null = null;
  private regions$: Observable<any[]> | null = null;
  private regionMappings$: Observable<any> | null = null;
  private languages$: Observable<any[]> | null = null;

  constructor(private http: HttpClient) { }

  getLanguages(): Observable<any[]> {
    if (!this.languages$) {
      this.languages$ = this.http.get<any[]>(this.baseUrl + 'languages').pipe(
        shareReplay(1),
        catchError(err => { this.languages$ = null; return throwError(() => err); })
      );
    }
    return this.languages$;
  }

  getCountries(): Observable<any[]> {
    if (!this.countries$) {
      this.countries$ = this.http.get<any[]>(this.baseUrl).pipe(
        shareReplay(1),
        catchError(err => { this.countries$ = null; return throwError(() => err); })
      );
    }
    return this.countries$;
  }

  searchCountries(search: string): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + 'search?search=' + search);
  }

  // The sub-national units a participant actually picks from, keyed by country, each with the region
  // it resolves to and its translations. Distinct from getRegionsPerCountry, which returns the coarse
  // regions a quota targets. The US is absent — it resolves its region from a postal code instead.
  getRegionMappingsPerCountry(): Observable<any> {
    if (!this.regionMappings$) {
      this.regionMappings$ = this.http.get<any>(this.baseUrl + 'region-mappings').pipe(
        shareReplay(1),
        catchError(err => { this.regionMappings$ = null; return throwError(() => err); })
      );
    }
    return this.regionMappings$;
  }

  getRegionsPerCountry(): Observable<any[]> {
    if (!this.regions$) {
      this.regions$ = this.http.get<any[]>(this.baseUrl + 'regions').pipe(
        shareReplay(1),
        catchError(err => { this.regions$ = null; return throwError(() => err); })
      );
    }
    return this.regions$;
  }
}
